export function startTyping(text, updateCallback, adjustHeightCallback) {
    const state = { index: 0, value: '' };
    const baseInterval = 15;
    const intervalTime = text.length > 100 ? baseInterval / 3 : baseInterval;
    const interval = setInterval(() => textType(text, state, updateCallback, adjustHeightCallback, interval), intervalTime);

}

function textType(text, state, updateCallback, adjustHeightCallback, interval) {
    if (state.index < text.length) {
        state.value += text.charAt(state.index);
        state.index++;
        updateCallback(state.value);
        adjustHeightCallback();
    } else {
        clearInterval(interval);
    }
}

export function adjustHeight(el) {
    if (el) {
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
    }
}
document.addEventListener('click', function(event) {
    const additionalInfo = document.querySelector('.ai-input');

    if (additionalInfo && !additionalInfo.contains(event.target)) {
        additionalInfo.classList.remove('focus');
    }
});

export function focusOnAIInput() {
    document.querySelector('.conclusion').classList.add('focus');
}
